import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "panelToggle",
    "panelChevron",
    "panelHintShow",
    "panelHintHide",
    "panelCollapsedHint",
    "panelSummary",
    "filtersPanel",
    "scheduleToggle",
    "schedulePanel",
    "scheduleChevron",
    "refineToggle",
    "refinePanel",
    "refineChevron"
  ]

  static values = {
    panelExpanded: Boolean,
    scheduleExpanded: Boolean,
    refineExpanded: Boolean
  }

  connect() {
    if (this.panelExpandedValue) {
      this.expandPanel()
    } else {
      this.collapsePanel()
    }
  }

  togglePanel() {
    if (this.filtersPanelTarget.classList.contains("hidden")) {
      this.expandPanel()
    } else {
      this.collapsePanel()
    }
  }

  toggleSchedule() {
    if (this.schedulePanelTarget.classList.contains("hidden")) {
      this.expandSchedule()
    } else {
      this.collapseSchedule()
    }
  }

  toggleRefine() {
    if (this.refinePanelTarget.classList.contains("hidden")) {
      this.expandRefine()
    } else {
      this.collapseRefine()
    }
  }

  expandPanel() {
    this.element.classList.remove("browse-filters--panel-collapsed")
    this.element.classList.add("browse-filters--panel-expanded")
    this.filtersPanelTarget.classList.remove("hidden")
    this.panelToggleTarget.setAttribute("aria-expanded", "true")
    this.panelChevronTarget.classList.add("rotate-180")
    if (this.hasPanelHintShowTarget) this.panelHintShowTarget.classList.add("hidden")
    if (this.hasPanelHintHideTarget) this.panelHintHideTarget.classList.remove("hidden")
    if (this.hasPanelCollapsedHintTarget) this.panelCollapsedHintTarget.classList.add("hidden")
    if (this.hasPanelSummaryTarget) this.panelSummaryTarget.classList.add("hidden")

    if (this.scheduleExpandedValue) this.expandSchedule()
    if (this.refineExpandedValue) this.expandRefine()
  }

  collapsePanel() {
    this.element.classList.add("browse-filters--panel-collapsed")
    this.element.classList.remove("browse-filters--panel-expanded")
    this.filtersPanelTarget.classList.add("hidden")
    this.panelToggleTarget.setAttribute("aria-expanded", "false")
    this.panelChevronTarget.classList.remove("rotate-180")
    if (this.hasPanelHintShowTarget) this.panelHintShowTarget.classList.remove("hidden")
    if (this.hasPanelHintHideTarget) this.panelHintHideTarget.classList.add("hidden")
    if (this.hasPanelCollapsedHintTarget) {
      this.panelCollapsedHintTarget.classList.toggle("hidden", this.hasPanelSummaryTarget)
    }
    if (this.hasPanelSummaryTarget) this.panelSummaryTarget.classList.remove("hidden")

    this.collapseSchedule()
    this.collapseRefine()
    this.schedulePicker?.closeAllDropdowns()
  }

  expandSchedule() {
    this.schedulePanelTarget.classList.remove("hidden")
    this.scheduleToggleTarget.setAttribute("aria-expanded", "true")
    this.scheduleChevronTarget.classList.add("rotate-180")
  }

  collapseSchedule() {
    this.schedulePanelTarget.classList.add("hidden")
    this.scheduleToggleTarget.setAttribute("aria-expanded", "false")
    this.scheduleChevronTarget.classList.remove("rotate-180")
    this.schedulePicker?.closeAllDropdowns()
  }

  expandRefine() {
    this.refinePanelTarget.classList.remove("hidden")
    this.refineToggleTarget.setAttribute("aria-expanded", "true")
    this.refineChevronTarget.classList.add("rotate-180")
  }

  collapseRefine() {
    this.refinePanelTarget.classList.add("hidden")
    this.refineToggleTarget.setAttribute("aria-expanded", "false")
    this.refineChevronTarget.classList.remove("rotate-180")
  }

  get schedulePicker() {
    return this.application.getControllerForElementAndIdentifier(this.element, "browse-schedule-picker")
  }
}
